function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#center2_svg__clip0_1_28)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.832 8A2.825 2.825 0 018 10.82a2.826 2.826 0 01-2.832-2.818V8A2.825 2.825 0 018 5.183 2.826 2.826 0 0110.832 8zM8 13.17c-2.89 0-5.235-2.322-5.235-5.186 0-2.866 2.344-5.187 5.235-5.187 2.89 0 5.235 2.321 5.235 5.187 0 2.864-2.344 5.186-5.235 5.186zm6.852-6.1c-.417-3.04-2.848-5.448-5.92-5.858L8.923.3a.305.305 0 00-.311-.3L7.348.014a.305.305 0 00-.302.308l.01.892c-3.066.414-5.492 2.82-5.908 5.856H.305c-.17 0-.305.204-.305.453v.955c0 .25.136.452.305.452h.843c.417 3.04 2.847 5.448 5.917 5.859l.006.86c.002.196.141.353.31.351l1.265-.01c.168-.001.305-.16.304-.355l-.007-.847c3.066-.414 5.493-2.82 5.909-5.858h.843c.17 0 .305-.202.305-.452v-.955c0-.25-.136-.453-.305-.453h-.843z",
  fill: "currentColor"
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "center2_svg__clip0_1_28"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})));
function SvgCenter2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}
export default SvgCenter2;